import { createFormHookContexts } from '@tanstack/react-form';

// Contexts live apart from the hook wiring in appForm.tsx so field
// components can consume them without a circular import.
export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();
